import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import Background from '../../../../components/Editor/Spread/Background';
import {
	isEditableSpread,
	getGeneralBgData,
	getSpreadBgData,
} from '../../selectors';
import { PositionConfig, BackgroundMediaType, BackgroundImageOrMovieData } from '../../reducer';
import * as helpers from '../../utils/helpers';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads, currentSpreadIndex },
			spreadBackground: { isActive },
			editPanel: { isDisplayed: isEditPanelDisplayed },
			thumbnails,
		},
		galleryInfos: { config },
	} = state;
	const { tempGId: resourceId } = helpers.getClientAndResourceIds();
	const backgroundData = getSpreadBgData(state, spreads[currentSpreadIndex]) || getGeneralBgData(state);
	let url = '';
	let mediaType = BackgroundMediaType.IMAGE;
	let defaultMediaType = BackgroundMediaType.IMAGE;
	let colors: (string | undefined)[] | undefined;
	let position: PositionConfig | undefined;

	if (backgroundData) {
		const { currentMedia, defaultMedia, defaultColors } = backgroundData;

		if (currentMedia) {
			const { type } = currentMedia;

			if (type === BackgroundMediaType.SLIDER && 'slides' in currentMedia) {
				if (currentMedia.slides[0]) {
					const { relUrl, iconName, externalRelUrl, isExternalLink } = currentMedia.slides[0];
					url = helpers.getSliderPreviewUrl(config, relUrl, isExternalLink, externalRelUrl, iconName);
				}
			} else if ('relUrl' in currentMedia) {
				url = helpers.getResourceUrl(currentMedia.relUrl, config, resourceId);

				if (type === BackgroundMediaType.MOVIE) {
					url = helpers.getVideoCover(url);
				}
			}

			mediaType = type;
		} else if (defaultColors.some(Boolean)) {
			colors = defaultColors;
		}

		if ((currentMedia || defaultMedia) && mediaType !== BackgroundMediaType.SLIDER) {
			position = ((currentMedia || defaultMedia) as BackgroundImageOrMovieData).position;
		}

		if (defaultMedia) {
			defaultMediaType = defaultMedia.type;
		} else if (currentMedia) {
			defaultMediaType = currentMedia.type;
		}
	}

	return {
		url,
		colors,
		position,
		isEditable: isEditableSpread(state),
		isActive,
		isEditPanelDisplayed,
		mediaType,
		defaultMediaType,
		thumbnailsWidth: thumbnails.width,
	};
};

export default connect(mapStateToProps)(Background);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Spread/Background/index.tsx